// eslint-disable-next-line no-undef
const { __ } = wp.i18n

// eslint-disable-next-line no-undef
const object = vnObject

const training = (item, highlighter, classes = 'g-col-12 g-col-sm-6') => {
  let icon
  switch (item.post_type.slug) {
    case 'continuing_trainings':
      icon = 'psychology'
      break
    case 'diploma_trainings':
      icon = 'arrow-left-right'
      break
    case 'region_trainings':
      icon = 'business-center'
      break
  }
  return `
    <article class="feed-training ${classes}">
        <a href="${item.url}" class="feed-training__wrapper" style="--bg: url(${item.images.large})">
            <span class="feed-training__icon ${item.post_type.slug}">
                <i class="vn-icons-wheel icon-bg"></i>
                <i class="vn-icons-${icon} icon"></i>
            </span>
            <div class="feed-training__contents">
                <span class="feed-training__title"
                >${item._highlightResult.title.value}</span>
            </div>
           
        </a>
    </article>
  `
}

const trainingHit = (item, classes = 'g-col-12 g-col-sm-6 g-col-lg-4') => {
  let icon
  switch (item.post_type.slug) {
    case 'continuing_trainings':
      icon = 'psychology'
      break
    case 'diploma_trainings':
      icon = 'arrow-left-right'
      break
    case 'region_trainings':
      icon = 'business-center'
      break
  }
  return `
    <article class="feed-training-hit type-${item.post_type.slug}${
      item.images.large ? ' has-post-thumbnail' : ''
    } ${classes}">
        <a href="${
          item.url
        }" class="feed-training-hit__wrapper" style="--bg: url(${
          item.images.large
        })">
            ${!item.images.large ? '<i class="vn-icons-big-wheel"></i>' : ''}
            <span class="feed-training-hit__icon ${item.post_type.slug}">
                <i class="vn-icons-wheel icon-bg"></i>
                <i class="vn-icons-${icon} icon"></i>
            </span>
            <div class="feed-training-hit__contents">
                <span class="feed-training-hit__title"
                >${item._highlightResult.title.value}</span>
            </div>
            ${item._highlightResult.subtitle ? '<div class="feed-training-hit__long-title-container"><span class="feed-training-hit__long-title">' + item._highlightResult.subtitle.value + '</span></div>' : ''}
            <div class="feed-training-hit__terms">
                <span class="feed-training-hit__term">${
                  item.post_type.name
                }</span>
                ${
                  item.diplomas.length
                    ? item.diplomas.map((diploma) => {
                        return `<span class="feed-training-hit__term">${diploma.name}</span>`
                      })
                    : ''
                }
                ${
                  item?.training_certifications_type?.length
                    ? item.training_certifications_type.map((certType) => {
                        return `<span class="feed-training-hit__term">${certType.name}</span>`
                      })
                    : ''
                }
            </div>
        </a>
    </article>
  `
}

const noResult = `<div class="feed-none g-col-6">${__(
  'There were no results!',
  'vn'
)}</div>`

const allTrainings = `<a href="${object.trainingsPage}" data-orig-href="${
  object.trainingsPage
}" class="all-trainings g-col-12 g-col-sm-6">
<span class="all-trainings__title">${__('See all trainings', 'vn')}</span>
<span class="all-trainings__icon"><i class="vn-icons-wheel"></i><i class="vn-icons-search"></i></span>
</a>`

export { training, noResult, allTrainings, trainingHit }
